<div #refModalTrigger><ng-content select="[trigger]"></ng-content></div>
@if ((refModalTrigger.children.length == 0)) {
  <div>
    <button nz-button nzType="primary" (click)="showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>{{triggerTitle}}</span>
    </button>
  </div>
}
<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1000"
  (nzAfterOpen)="afterModalOpen()"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="manual-input-switch">
      Manuelle Eingabe
      <nz-switch [(ngModel)]="isManualInput"></nz-switch>
    </div>
    <div class="scan-field">
      Die Auftragsnummer scannen: <input [(ngModel)]="orderNumber" (ngModelChange)="handleNumberScan($event)" appPossitiveNumbers #scanField nz-input>
      &nbsp;<button nz-button nzType="primary">
      <i nz-icon nzType="barcode" nzTheme="outline" (click)="handleBarcodeScanner()"></i>
    </button>
  </div>

  <app-process-form #form [orderNumber]="numberChanged$ | async" (formFinished)="onFormFinished($event)" (statusChange)="handleChangeStatus($event)"></app-process-form>
</ng-template>

<ng-template #modalFooter>
  @if (form && form.currentStatus === orderStatuses.MhdChecked) {
    <button
      nz-button
      nzType="default"
      (click)="printLabels()"
    >Etiketten drucken</button>
  }

  <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>

  @if (orderStatus === orderStatuses.Created) {
    <button
      nz-button nzType="primary"
      (click)="handleOk()"
      [nzLoading]="isConfirmLoading"
      >Abgefüllt
    </button>
  }

  @if (orderStatus === orderStatuses.MhdChecked) {
    <button
      nz-button nzType="primary"
      (click)="handleOk()"
      [nzLoading]="isConfirmLoading"
      >Etikettiert
    </button>
  }

  @if (orderStatus && orderStatus === orderStatuses.Labeled) {
    <button
      nz-button
      nzType="primary"
      (click)="handleInsert()"
      [nzLoading]="isConfirmLoading"
      >Einbuchen
    </button>
  }
</ng-template>
</nz-modal>

<ng-template #variantsWithoutLabelKey>
  <h3 style="padding-bottom: 16px;">Unterhalb von Variantenlabels werden keine Labels generiert, füllen Sie zuerst Variantenlabels.</h3>
  @if (form) {
    <nz-table #tableRef [nzData]="form.editObject.article.articleVariants" [nzShowPagination]="false">
      <thead>
        <tr>
          <th nzColumnKey="id">Variantenname</th>
          <th nzColumnKey="createdAt">Bestellnummer</th>
        </tr>
      </thead>
      <tbody>
        @for (variant of (form.editObject.productionOrderVariants | getVariantsWithoutLabel); track variant) {
          <tr>
            <td>{{ variant.articleVariant.name }}</td>
            <td>{{ variant.articleVariant.orderNumber }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  }
</ng-template>
